<template>
	<div class="row">
		<div class="col-12">
			<h3 class="section">{{title}}</h3>
		</div>
	</div>
</template>

<script>
export default {
	name: "SectionTitle",
	props: {
		title: String
	}
}
</script>
